<template>
  <security-gate :roles="['feature.sysadmin']">
    <h2>Vapps Support Pages</h2>

    <b-card-group columns>
      <b-card title="Month Comparison">
        <p class="card-text">
          Compare last month's results to this month's results and
          detect anomalous or missing extracts based on normal historical
          behaviour.
        </p>
        <b-link :to="{name:'support-month-comparison'}" class="card-link">View report</b-link>
      </b-card>
    </b-card-group>

    <hr style="margin: 30px 0"/>

    <h4 style="margin: 30px 0">Stealing notifications</h4>
    <b-tabs>
      <b-tab active title="Steal">
        <steal/>
      </b-tab>
      <b-tab title="Unsteal">
        <unsteal/>
      </b-tab>
    </b-tabs>
  </security-gate>
</template>

<script>
import SecurityGate from '../components/SecurityGate.vue'
import Steal from '../components/support/Steal.vue'
import Unsteal from '../components/support/Unsteal.vue'

export default {
  components: { SecurityGate, Steal, Unsteal }
}
</script>
